import _ from 'lodash';
import orComparator from '../../../shared/util/lodash/merge/orComparator';
import useMyWorkspace from '../../workspace/hooks/useMyWorkspace';
import AlarmAPI from '../AlarmAPI';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { useMemo } from 'react';
import StructureAPI from '../../structure/StructureAPI';
import {
  ALARMS_POLLING_INTERVAL,
  AlarmsQueryParamsAPIRequest,
  AlarmState,
  excludedEventIdsStr,
} from '../Alarm.model';
import { patchLoadingState } from '../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';

type Options = Parameters<UseQuerySubscription<any>>[1];

function useAlarmsByUser(
  params?: AlarmsQueryParamsAPIRequest,
  options: Options = {}
) {
  const { data: workspaceData, ...restWorkspaceAPI } = useMyWorkspace(
    undefined,
    options
  );
  const workspaceId = workspaceData?.id;
  const { data: devicesAPI, ...restDevicesAPI } =
    StructureAPI.useGetStructureV2Query(undefined, options);
  const devicesIdsFromGroup = devicesAPI?.commanderIds;

  const { data: alarmsData, ...restAlarmAPI } =
    AlarmAPI.useGetFlexeserveIncidentByUserQuery(
      {
        workspaceId: workspaceId ?? '',
        params: {
          state: AlarmState.NEW,
          excluded_event_ids: excludedEventIdsStr,
          page_size: 1000,
          ...params,
        },
      },
      {
        pollingInterval: ALARMS_POLLING_INTERVAL,
        ...options,
        skip: !workspaceId || options.skip,
      }
    );

  const allAlarms = useMemo(
    () =>
      alarmsData?.data?.filter?.((alarm) =>
        devicesIdsFromGroup?.includes(alarm.deviceId)
      ),
    [alarmsData, devicesIdsFromGroup]
  );

  const response = _.chain(patchLoadingState(restAlarmAPI))
    .mergeWith(patchLoadingState(restDevicesAPI), orComparator)
    .mergeWith(patchLoadingState(restWorkspaceAPI), orComparator)
    .value();
  return patchLoadingState({
    ...response,
    currentData: restAlarmAPI.currentData,
    data: alarmsData?.data ?? [],
    count: alarmsData?.count ?? 0,
    allAlarms,
  });
}

export default useAlarmsByUser;
